<template>
  <div class="table">
    <!--=========查询模块================-->
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="用户名" prop="name">
                <el-input class="handle-input" v-model.trim="queryCondition.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="用户账户" prop="emplid">
                <el-input class="handle-input" v-model.trim="queryCondition.emplid"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="联系邮箱" prop="email">
                <el-input class="handle-input" v-model.trim="queryCondition.email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="phone">
                <el-input class="handle-input" v-model.trim="queryCondition.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="search">{{$t('common.search')}}</el-button>
            <el-button type="primary" @click="restQueryForm">{{$t('common.reset')}}</el-button>
            <el-button type="primary" @click="pickUp">{{$t('common.confirm')}}</el-button>
            <el-button type="primary" v-if="puMulti == true" @click="toggleSelection">{{$t('common.Deselected')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-table style="margin-top:20px" :data="tableData" ref="pickUserTable" row-key="tmUserId" border @selection-change="selectionChange" highlight-current-row>
        <el-table-column v-if="puMulti == true" prop="tmUserId" type="selection" width="55" align="center" :reserve-selection="true" />
        <el-table-column v-else width="100" :label="$t('common.select')" prop="name">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.tmUserId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="用户名"></el-table-column>
        <el-table-column show-overflow-tooltip prop="emplid" label="用户账户"></el-table-column>
        <el-table-column show-overflow-tooltip prop="email" label="联系邮箱"></el-table-column>
        <el-table-column show-overflow-tooltip prop="phone" label="联系电话"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getUsersEmail } from "@/api/visitPlan.js";
// import { userService } from "@/api/user-manage/user";

import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";

export default {
  name: "pickupUser",
  props: {
    value: String,
    title: String,
    multi: Boolean,
    placeholder: String,
    emplFlag: String,
    selectDatas: Array
  },
  data() {
    return {
      selectRows: [],
      puMulti: this.multi,
      puPlaceholder: this.placeholder,
      tableData: [],
      radioVal: null,
      selectedId: this.value,
      selectDataAll: this.multi
        ? {
          defaultData: commonFun.convertToArray(this.value),
          pageDatas: []
        }
        : null,
      totalCount: 0,
      labelPosition: "right",
      queryCondition: { pageSize: 15, pageNum: 1, name: "", emplid: "", email: '', phone: '' },
      showDialog: false,
      notSelRoles: [],
      selRoles: [],
      userId: null,
      userInfo: {},
      showUserInfo: false
    };
  },
  created() {
    this.queryData();
  },
  computed: {

    getSelectedData() {
      // if (this.multi) {
      //   let selectedData = [];
      //   let defaultData = this.selectDataAll.defaultData;
      //   if (commonFun.isNotEmpty(defaultData)) {
      //     selectedData.push(...defaultData);
      //   }
      //   let pageDatas = this.selectDataAll.pageDatas;
      //   for (let pageData of pageDatas.values()) {
      //     if (commonFun.isNotEmpty(pageData)) {
      //       selectedData.push(...pageData);
      //     }
      //   }
      //   return selectedData;
      // } else {
      //   return this.selectDataAll;
      // }
    },

    transferTo() {
      return this.value;
      if (commonFun.isEmpty(this.getSelectedData)) {
        return null;
      }
      if (this.puMulti) {
        return this.getSelectedData.map(user => user.name).join(";");
      } else {
        return this.selectDataAll.name;
      }
    }
  },
  watch: {
    value(newVal) {
      console.log(newVal);
      // this.selectDataAll.defaultData = commonFun.convertToArray(newVal);
    }
  },
  methods: {
    //单选操作
    getSelectRow: function (row) {
      this.selectRows = [];
      this.selectRows = row;
    },
    toggleSelection() {
      this.$refs.pickUserTable.clearSelection();
      // let rows = this.selectRows
      //   if (rows) {
      //     rows.forEach(row => {
      //       this.$refs.pickUserTable.toggleRowSelection(row);
      //     });
      //   } else {
      //     this.$refs.pickUserTable.clearSelection();
      //   }
    },
    queryData() {
      var that = this;
      this.queryCondition.emplFlag = this.emplFlag
      getUsersEmail(this.queryCondition)
        .then(res => {
          this.tableData = res.resultData;
          this.totalCount = res.totalCount;
          // this.tableData[1].value = true;
        })
        .then(value => {
          this.$nextTick(() => {
            that.updateCheck();
          });
        });
    },
    search() {
      this.queryCondition.pageNum = 1
      this.queryData();
    },
    pickUp() {
      if (this.multi) {//多选
        this.$emit("input", this.selectRows);
      } else {
        this.$emit("input", this.selectRows.name, this.selectRows.tmUserId);
        // this.$emit("getEmail", this.selectRows.email);
      }
    },
    selectionChange(rows) {
      let that = this
      this.selectRows = [];
      if (rows) {
        rows.forEach(val => {
          that.selectRows.push(val);
        });
      }
    },
    //页码变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //显示条数变更
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
    },
    editUserInfo(row) {
      this.userInfo = {};
      this.clearVlidate("userInfoForm");
      this.userInfo = row;
      this.showUserInfo = true;
    },
    updateCheck() {
      // if (!this.puMulti) {
      //   if (!commonFun.isEmpty(this.selectDataAll)) {
      //     this.tableData.forEach(row => {
      //       if (row.tmUserId == this.selectDataAll.tmUserId) {
      //         this.selectedId = row.tmUserId;
      //         this.selectDataAll = row;
      //       }
      //     });
      //   }
      // } else {
      //   var that = this;
      //   let defaultData = this.selectDataAll.defaultData;
      //   let existsArr = [];
      //   defaultData.forEach((data, i) => {
      //     if (commonFun.isNotEmpty(data)) {
      //       that.tableData.forEach(row => {
      //         if (row.tmUserId == data.tmUserId) {
      //           that.$refs["pickUserTable"].toggleRowSelection(row, true);
      //           existsArr.push(i);
      //         }
      //       });
      //     }
      //   });
      //   existsArr.forEach(i => {
      //     this.selectDataAll.defaultData.splice(i, 1);
      //   });
      // }
    }
  }
};
</script>
<style scoped>
.handle-input {
  width: 95%;
}

.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

/*穿梭框样式重写*/
.el-transfer .el-transfer-panel {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  display: inline-block;
  vertical-align: middle;
  width: 255px;
  max-height: 100%;
  box-sizing: border-box;
  position: relative;
}

.el-transfer-panel__body {
  height: 370px;
}

.el-transfer-panel__list.is-filterable {
  height: 360px;
}
</style>
